<template>
  <section>
    <template v-if="!isLoading">
      <div
        v-if="counter.value !== null"
        :style="`--lm-accent-color: ${accentColor}; --lm-accent-color-hover: ${accentColor}1A`"
        class="p-4 clickable counter-widget-wrapper"
        @click="onClick"
      >
        <span class="counter-text">{{ title }}</span>
        <div class="counter-widget">
          <div class="d-flex align-items-center justify-content-between">
            <span>
              <i class="icon mdi" :class="[counter.icon ? `mdi-${counter.icon}` : defaultIcon]"></i>
            </span>
            <span
              class="counter-value"
              :class="`calculate-${widget.calculate.id}`"
            >
              {{ renderValue() }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="p-4">
        <LmSvgIcon
          v-if="error"
          wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
          width="12em"
          icon="LmErrorIcon"
          text="No pudimos cargar el Widget."
        />
        <template v-else>
          <h4>Configura tu contador</h4>
          <p>Comienza a configurar tu contador desde el panel izquierdo para poder visualizarlo aquí mismo.</p>
        </template>
      </div>
    </template>
    <!-- loading state -->
    <template v-else>
      <b-skeleton-img no-aspect height="178px"></b-skeleton-img>
    </template>
  </section>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

// Vuex
import { mapGetters } from 'vuex'

export default {
  props: {
    widget: {
      type: Object
    },
    customization: {
      type: Object
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      error: false,
      counter: {
        title: null,
        icon: null,
        value: null
      }
    }
  },
  computed: {
    ...mapGetters('settings', ['accentColor']),
    title () {
      return this.customization?.title || this.counter.title
    },
    defaultIcon () {
      if (this.widget.calculate.id === 'min') {
        return 'mdi-sort-clock-ascending-outline'
      }
      if (this.widget.calculate.id === 'max') {
        return 'mdi-sort-clock-descending-outline'
      }
      if (this.widget.calculate.id === 'trees_saved') {
        return 'mdi-pine-tree'
      }
      if (this.widget.calculate.id === 'water_saved') {
        return 'mdi-water-outline'
      }
      if (this.widget.calculate.id === 'reams_saved') {
        return 'mdi-package-variant'
      }
      return 'mdi-text-box-check-outline'
    }
  },
  methods: {
    renderValue () {
      const countWidget = ['count', 'trees_saved', 'water_saved', 'reams_saved']
      if (countWidget.includes(this.widget.calculate.id)) {
        const sufix = this.widget.calculate.id === 'water_saved' ? ' l' : ''
        return this.counter.value + sufix
      }
      return `${this.counter.value.days} días, ${this.counter.value.hours}:${this.counter.value.minutes} hs`
    },
    async loadData (datatable) {
      try {
        this.isLoading = true
        this.error = false
        const res = await commonsApi.axiosPostWrapper('/widgets/generate-counter', {
          id: datatable.id,
          calc: this.widget.calculate.id
        })

        if (!this.widget.title) {
          this.widget.title = res.data.title
        }

        this.counter = {
          title: this.widget.title,
          icon: this.widget.icon,
          value: res.data.value
        }
      } catch (error) {
        console.log(error)
        this.error = true
      } finally {
        this.isLoading = false
      }
    },
    onClick () {
      this.$router.push(`/listado/${this.widget.dataOrigin.slug}`)
    }
  },
  watch: {
    widget: {
      deep: true,
      async handler (val) {
        if (val.dataOrigin) {
          await this.loadData(val.dataOrigin)
        } else {
          this.counter.title = null
          this.counter.icon = null
          this.counter.value = null
        }
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.widget.dataOrigin) {
        await this.loadData(this.widget.dataOrigin)
      } else {
        this.counter.title = null
        this.counter.icon = null
        this.counter.value = null
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.counter-widget-wrapper {
  color: var(--lm-accent-color);
}

.counter-widget-wrapper:hover {
  background-color: var(--lm-accent-color-hover);
}

.counter-text {
  font-weight: bold;
  font-size: 1rem;
}

.counter-widget {
  padding: 0.5rem 0;
}

.counter-widget .counter-value {
  font-weight: bold;
  font-size: 3.8rem;
}

.counter-widget .counter-value.calculate-min,
.counter-widget .counter-value.calculate-max,
.counter-widget .counter-value.calculate-average {
  font-size: 2rem;
}

.counter-widget .icon {
  font-size: 3rem;
}
</style>
